<template>
  <div style="padding: 10px 20px;">
    <vxe-toolbar
      id="toolbarId_or11"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      height="600"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!--      <vxe-table-column field="code" title="code" min-width="160" sortable>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        field="relationNumber"
        title="主订单号"
        min-width="200"
        sortable
      />
      <vxe-table-column
        field="gmtCreated"
        title="下单时间"
        min-width="160"
        sortable
      />
      <vxe-table-column
        field="shipmentName"
        title="托运人名称"
        min-width="160"
        sortable
      />
      <vxe-table-column
        field="shipmentPhone"
        title="托运人手机号"
        min-width="160"
        sortable
      >
        <!--        <template v-slot:header>-->
        <!--          <el-input v-model="listQuery.shipmentPhone" placeholder="托运人手机号" clearable/>-->
        <!--        </template>-->
      </vxe-table-column>
      <vxe-table-column
        field="transportType"
        title="订单类型"
        :formatter="formatterTransportType"
        min-width="130"
        sortable
      >
        <!--        <template v-slot:header>-->
        <!--          <el-select v-model="form.transportType" placeholder="&#45;&#45;请选择&#45;&#45;" clearable>-->
        <!--            <el-option-->
        <!--              v-for="item in formatterTransportTypeOptions"-->
        <!--              :key="item.value"-->
        <!--              :label="item.label"-->
        <!--              :value="item.value"-->
        <!--            />-->
        <!--          </el-select>-->
        <!--        </template>-->
      </vxe-table-column>
      <!--      <vxe-table-column field="loadingAddress" title="发货方地址" min-width="160" sortable>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        field="transportType"
        title="运输方式"
        min-width="160"
        :formatter="formatterTransportType"
        sortable
      />
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column field="licenseNumber" title="接货车牌号" min-width="160"/>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        field="totalUpstreamFreight"
        title="总上游运费"
        min-width="160"
        sortable
      />
      <vxe-table-column
        field="totalDriverFreight"
        title="总实际承运人运费"
        min-width="160"
        sortable
      />
      <!--      <vxe-table-column field="driverFreight" title="实际承运人运费" min-width="160">-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        field="collectionDelivery"
        title="代收款"
        min-width="160"
        sortable
      />
      <vxe-table-column title="操作" fixed="right" min-width="80">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看运单"
            placement="top"
          >
            <vxe-button type="text" @click="checkOrderDetails(scope.row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="isorderManage"
      title="查看运单"
      width="65%"
      height="auto"
      resize
    >
      <orderCount
        ref="OrderRef"
        @fatherCancelMethod="fatherCancel"
        @hideModel="hideModel"
      />
    </vxe-modal>
  </div>
</template>
<script>
import { delVehicleInsurance } from "@/api/vehicleService";
import { ajax } from "@/api/ctms";

import orderCount from "@/views/components/orderListSelect.vue";
export default {
  name: "Parent",
  components: {
    orderCount
  },
  data() {
    return {
      loading: false,
      form: { pageNum: 1, pageSize: 10 },
      tableData: [],
      formatterDetailStatusOptions: [
        { label: "未接单", value: 0, color: "gray" },
        { label: "已接单", value: 1, color: "#0000ff" },
        { label: "已运输", value: 2, color: "#ff0000" },
        { label: "已签收", value: 3, color: "#00bd93" }
      ],
      formatterTransportTypeOptions: [
        { label: "零担", value: 1, color: "gray" },
        { label: "包车", value: 0, color: "#0000ff" }
      ],
      orderCode: "",
      modelAddFlag: false,
      modelEditFlag: false,
      isorderManage: false,
      type: 0,
      listQuery: {
        shipmentName: "",
        shipmentPhone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {},
  methods: {
    findList() {
      ajax(
        "/ntocc-ctms-api/ctmsOrderRelation/queryOrderRelationList",
        "get",
        this.listQuery
      )
        .then(data => {
          this.listQuery.total = data.data.total;
          this.tableData = data.data.records;
          data.data.total
            ? (this.Pagingconf = [20, 30, 50, 100, data.data.total])
            : (this.Pagingconf = [20, 30, 50, 100]);
          this.loading = false;
        })
        .catch(error => {});
    },
    checkOrderDetails(data) {
      this.$refs.OrderRef.listQuery.orderRelationCode = data.code;
      this.$refs.OrderRef.findList();
      this.isorderManage = true;
    },
    formatterCommon({ cellValue, options }) {
      const item = options.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterTransportType({ cellValue }) {
      const item = this.formatterTransportTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterDetailStatus({ cellValue }) {
      const item = this.formatterDetailStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 展示弹框
    showModel(code, costRemark, prefix) {
      if (code) {
        this.$refs[`${prefix}Ref`].getInfo(code, costRemark);
      }
      this[`model${prefix}Flag`] = true;
    },
    // 隐藏弹框
    hideModel() {
      this.modelAddFlag = false;
      this.modelEditFlag = false;
      this.findList();
    },
    // 删除
    funcDelete(codes) {
      this.$confirm("确认删除吗？").then(_ => {
        delVehicleInsurance({ codes }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.orderCount = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
      this.findList();
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
<style scoped>
::v-deep.el-dialog__body {
  padding: 5px;
}
::v-deep .el-dialog__header {
  padding: 10px;
}
</style>
